import React, { useEffect, useState } from "react";
import ReactMarkdown from "react-markdown";
import PrivacyText from "../content/Privacy.js";
import "../styles/markdown.css";

import { Link, useNavigate } from "react-router-dom";
import Header from "../components/layout/Header";
import Footer from "../components/layout/Footer";

function Privacy() {
  return (
    <div>
      <Header />
      <div className="container">
        <div className="markdown-container">
          <ReactMarkdown>{PrivacyText}</ReactMarkdown>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default Privacy;
